import { render, staticRenderFns } from "./pulsDetails.vue?vue&type=template&id=19705536&scoped=true&"
import script from "./pulsDetails.vue?vue&type=script&lang=js&"
export * from "./pulsDetails.vue?vue&type=script&lang=js&"
import style0 from "./pulsDetails.vue?vue&type=style&index=0&id=19705536&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19705536",
  null
  
)

export default component.exports